import { takeLatest } from 'redux-saga/effects'
import { FeatureFlagKeys } from 'typings'

import request from 'services/Request'
import { SemverComparisonResult, compareSemvers, parseSemver } from '../utils'

import * as actionTypes from '../actionTypes'
import * as api from '../api'

let previousStableVersionString: string | undefined

export function* checkLocalisationUpdateWorker(action: ActionType) {
  const { country, flagUpdates, currentVersionString } = action.payload
  const currentVersion =
    currentVersionString && parseSemver(currentVersionString)

  if (!currentVersion) {
    // Current localisation version is not stored or is invalid (doesn't satisfy semver regex)
    return
  }

  let newStableVersionString = flagUpdates[
    FeatureFlagKeys.STABLE_LOCALISATION_VERSION
  ] as string | undefined

  if (previousStableVersionString === newStableVersionString) {
    // As the flags haven't changed since last fetch we do not need to check for diff again
    return
  }
  previousStableVersionString = newStableVersionString

  const newStableVersion =
    (newStableVersionString && parseSemver(newStableVersionString)) ||
    currentVersion

  if (
    compareSemvers(currentVersion, newStableVersion) !==
    SemverComparisonResult.LOWER
  ) {
    // Neither stable version nor canary version is higher than current version
    return
  }

  if (
    compareSemvers(currentVersion, newStableVersion) !==
    SemverComparisonResult.LOWER
  ) {
    newStableVersionString = currentVersionString
  }

  const args: api.GetWordingProps = {
    country,
    currentVersion: currentVersionString,
    stableVersion: newStableVersionString!,
  }
  yield request(actionTypes.UPDATE_LOCALISATIONS, api.getLocalisationDiff, args)
}

export default function* checkLocalisationUpdateSaga() {
  yield takeLatest(
    [actionTypes.CHECK_LOCALISATION_UPDATE, actionTypes.UPDATE_LOCALISATIONS],
    checkLocalisationUpdateWorker,
  )
}
